module.exports = __webpack_public_path__ + "img/29-SR8.c48854f.png";